import React, { useState } from 'react';
import { useEffect } from 'react';
import { Box, Paper, Stepper, Step, StepLabel, Button, Typography, Snackbar, Alert, useMediaQuery, useTheme,  List, ListItem, ListItemIcon, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, CircularProgress, DialogActions } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import HeaderEntreprise from '../../header/headerEntreprise';
import { useNavigate } from 'react-router-dom';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import InfoIcon from '@mui/icons-material/Info';
import DescriptionIcon from '@mui/icons-material/Description';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import './Addmission.css';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import PresentationModal from '../../Recruteur/candidat/detailTalent/PresentationModal';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const steps = ['Informations mission', 'Profil recherché', 'Contact'];

export default function Addmission() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [usersList, setUsersList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [mission, setMission] = useState(true);
  const [createdTalentId, setCreatedTalentId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleClose = () => setModalOpen(false);
  const [isDraft, setIsDraft] = useState(false);

  const [formData, setFormData] = useState({
    nomMission: '',
    lieuxTravail: '',
    remuneration: '',
    dateDebut: null,
    urgenceMission: "Normale",

    modeTravail: '',
    contexteMission: '',
    document: null,
    typeContrat:'',
    competences: [],
    criteres: [],
    softSkills: [],
    langues: [],
    experience: '',
    formation: '',
    secteur: '',
    nom: '',
    email: '',
    telephone: '',
    role: '',
    dateLimite: null,
    recruteursMax: '',
    placesDispo: '',
    garantie: '',
    devise: 'EUR',
    infoComplementaires: '',
    contrats: [],
  });


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const entrepriseId = localStorage.getItem('userId');
        const res = await fetch(`${API_BASE}/api/entreprise/profil/${entrepriseId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const entreprise = await res.json();

        const users = [
          {
            id: entreprise.utilisateur?._id,
            nom: `${entreprise.utilisateur?.firstName || ''} ${entreprise.utilisateur?.lastName || ''}`.trim(),
            email: entreprise.utilisateur?.email,
            telephone: entreprise.utilisateur?.phone,
          },
          ...(entreprise.utilisateursAdditionnels || []).map(u => ({
            id: u._id,
            nom: `${u.firstName || ''} ${u.lastName || ''}`.trim(),
            email: u.email,
            telephone: u.phone,
          }))
        ].filter(u => u.email); 

        setUsersList(users);
      } catch (err) {
        console.error('Erreur chargement users:', err);
      }
    };
    fetchUsers();
  }, [API_BASE]);

  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const validateStep = (step) => {
    const newErrors = {};
  
    if (step === 0) {
      ['nomMission', 'lieuxTravail', 'remuneration', 'contexteMission'].forEach(k => {
        if (!formData[k]) newErrors[k] = 'Champ requis';
      });
    }
  
    if (step === 1) {

      ['competences'].forEach(field => {
        if (!Array.isArray(formData[field]) || formData[field].length === 0) {
          newErrors[field] = 'Veuillez valider vos saisies en appuyant sur Entrée.';
        }
      });

      const requiredFields = ['typeContratDetails', 'secteur'];
      requiredFields.forEach(field => {
        if (!formData[field] || String(formData[field]).trim() === '') {
          newErrors[field] = 'Champ requis';
        }
      });
    }
  
    if (step === 2) {
      ['nom', 'email', 'telephone', 'dateLimite','placesDispo'].forEach(k => {
        if (!formData[k]) newErrors[k] = 'Champ requis';
      });
    }
  
    setErrors(newErrors);
  
    if (Object.keys(newErrors).length > 0) {
      const specificError = Object.values(newErrors).find(e => e.includes('valider vos saisies'));
      setSnackbar({
        open: true,
        message: specificError || 'Merci de remplir tous les champs obligatoires.',
        severity: 'error',
      });
      return false;
    }
  
    return true;
  };
  
  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((s) => s + 1);
    }
  };  
  
  const handleBack = () => setActiveStep(s => s - 1);

  const readFileAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsDataURL(file);
    });
  };
  
  const autoFillDraftFields = (data) => {
    return {
      ...data,
      nomMission: data.nomMission || 'Sans titre',
      lieuxTravail: data.lieuxTravail || 'Non précisé',
      remuneration: data.remuneration || '0',
      contexteMission: data.contexteMission || 'A compléter',
      competences: Array.isArray(data.competences) && data.competences.length > 0 
      ? data.competences 
      : ['Non précisé'],
      nom: data.nom || 'Responsable',
      email: data.email || 'email@placeholder.com',
      telephone: data.telephone || '0000000000',
      role: data.role || 'Responsable RH',
      dateLimite: data.dateLimite || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      placesDispo: data.placesDispo || '1',
    };
  };
  
  
  const handleFinish = async (asDraft = false) => {
    setIsDraft(asDraft);
    if (!formData.nomMission || formData.nomMission.trim() === "") {
      setErrors((prev) => ({ ...prev, nomMission: "L'intitulé de la mission est obligatoire." }));
      setSnackbar({
        open: true,
        message: "Veuillez saisir l'intitulé de la mission.",
        severity: "error",
      });
      return;
    }
  
    if (!formData.lieuxTravail || formData.lieuxTravail.trim() === "") {
      setErrors((prev) => ({ ...prev, lieuxTravail: "Le lieu de travail est obligatoire." }));
      setSnackbar({
        open: true,
        message: "Veuillez saisir le lieu de travail.",
        severity: "error",
      });
      return;
    }
  
    if (!asDraft && !validateStep(2)) {
      setSnackbar({
        open: true,
        message: 'Merci de remplir tous les champs obligatoires.',
        severity: 'error',
      });
      return;
    }
  
    setIsSubmitting(true);
  
    const token = localStorage.getItem('authToken');
    const entrepriseId = localStorage.getItem('userId');
  
    try {
      let documentPayload = null;

      if (formData.document instanceof File) {
        const base64 = await readFileAsDataURL(formData.document);
        documentPayload = {
          name: formData.document.name,
          data: base64,
        };
      } else if (formData.document?.data && formData.document?.name) {
        documentPayload = formData.document;
      }
      
      if (documentPayload) {
        const isValidBase64 =
          typeof documentPayload.data === 'string' &&
          documentPayload.data.startsWith('data:') &&
          documentPayload.data.includes('base64,');
      
        if (!isValidBase64 || !documentPayload.name) {
          console.warn('📄 Document invalide, suppression du payload');
          documentPayload = null;
        }
      }
      
      const cleanedData = asDraft ? autoFillDraftFields(formData) : formData;
      
      const payload = {
        ...cleanedData,
        status: asDraft ? 'brouillon' : 'active',
        createdBy: entrepriseId,
        garantie: cleanedData.garantie ? `${cleanedData.garantie} mois` : '',
        document: documentPayload,
        placesDispo: cleanedData.placesDispo,
        contrats: (cleanedData.typeContratDetails || []).map(c => ({
          type: c.contrat,
          tarifMin: Number(c.tarifMin),
          tarifMax: Number(c.tarifMax),
          devise: c.devise
        })),
        typeContrat: (cleanedData.typeContratDetails || []).map(c => c.contrat),
        langues: Array.isArray(cleanedData.langues)
          ? cleanedData.langues.filter(
              (lang) => typeof lang === 'object' && lang.langue && lang.niveau
            )
          : [],
      };
      
      if (!documentPayload) {
        delete payload.document;
      }
      
      const res = await fetch(`${API_BASE}/api/missions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (!res.ok) {
        const err = await res.json();
        throw err;
      }
  
      const createdMission = await res.json();
      setMission(createdMission);
      setSnackbar({
        open: true,
        message: asDraft ? 'Brouillon enregistré !' : 'Mission créée avec succès !',
        severity: 'success',
      });
  
      setSuccessDialogOpen(true);
    } catch (err) {
      console.error('❌ handleFinish error:', err);
      setSnackbar({
        open: true,
        message: err.message || 'Erreur serveur.',
        severity: 'error',
      });
      setIsSubmitting(false);
    }
  };
  
  
  
    

  const handleChange = (field, value) => {
    setFormData(f => ({ ...f, [field]: value }));
    setErrors(e => ({ ...e, [field]: undefined }));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box className="addmission-wrapper">
        <HeaderEntreprise entrepriseName={localStorage.getItem('entrepriseName')} />
        <Paper elevation={0} className="addmission-stepper-wrapper">
          <Stepper
            activeStep={activeStep}
            alternativeLabel={!isMobile}
            orientation={isMobile ? 'vertical' : 'horizontal'}
          >
            {steps.map(label => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Paper>

        <Box className="addmission-content">
          <Box component={Paper} elevation={1} className="addmission-main-form">
          {activeStep === 0 && <StepOne data={formData} errors={errors} onChange={handleChange} />}
          {activeStep === 1 && <StepTwo data={formData} errors={errors} onChange={handleChange} />}
          {activeStep === 2 && (<StepThree data={formData} errors={errors} onChange={handleChange} users={usersList}/>)}

            <Box className="addmission-navigation-buttons">
            <Button disabled={activeStep === 0} onClick={handleBack}>← Précédent</Button>
            <Button variant="contained" onClick={() => handleFinish(true)}>Brouillon</Button>
            {activeStep < steps.length - 1 ? (
                <Button variant="contained" onClick={handleNext}>Suivant →</Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={() => handleFinish(false)}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Veuillez patienter...' : 'Valider'}
                </Button>
              )}
            </Box>
          </Box>

        <Box component={Paper} elevation={2} className="addmission-sidebar" sx={{ padding: '20px', backgroundColor: '#f7f9fc' }}>
          <List>
            <ListItem>
              <ListItemIcon>
                <InfoIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="h6" color="primary">Informations du poste</Typography>}
                secondary="L'intitulé du poste apparaîtra en haut de votre annonce."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <DescriptionIcon color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="h6" color="secondary">Contexte de la mission</Typography>}
                secondary="Une description détaillée permet aux recruteurs de mieux cerner vos besoins."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <MonetizationOnIcon color="success" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="h6" color="success.main">Prime</Typography>}
                secondary="La prime concerne le recruteur et sera touchée selon le profil proposé, recruté ou non."
              />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <SmartToyIcon color="error" />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="h6" color="error.main">Important - Matching par IA</Typography>}
                secondary="Notre IA utilise les informations saisies pour un matching précis et pertinent. Veuillez remplir chaque champ avec attention pour optimiser les résultats proposés."
              />
            </ListItem>
          </List>
        </Box>
        </Box>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
        >
          <Alert
            onClose={() => setSnackbar(s => ({ ...s, open: false }))}
            severity={snackbar.severity}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        <Footer />
        <Chatbox userRole="entreprise" />
      </Box>

      <Box>
      <Dialog
        open={successDialogOpen}
        fullWidth
        maxWidth="sm"
        PaperProps={{ style: { textAlign: 'center', padding: '20px', borderRadius: '15px' } }}
      >
        <DialogTitle>
            <Typography variant="h5" gutterBottom color="primary">
              <CheckCircleOutlineIcon fontSize="large" style={{ verticalAlign: 'middle', marginRight: 8 }} />
              {isDraft ? 'Brouillon enregistré' : 'Mission ajoutée avec succès 🎉'}
            </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
              <Typography variant="subtitle1">
              {isDraft ? (
                <Typography variant="subtitle1">
                  Votre mission a été enregistrée en tant que brouillon.  
                  Vous pourrez la compléter et la publier plus tard depuis votre tableau de bord.
                </Typography>
              ) : (
                <Typography variant="subtitle1">
                    Vous pouvez consulter les détails de la mission. <p></p>
              Le profil sera automatiquement transmis au recruteur, accompagné d'une analyse de compatibilité générée par notre moteur d’intelligence artificielle.
                </Typography>
              )}
              </Typography>
          </DialogContentText>
        </DialogContent>
          <DialogActions >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/Entreprise/Details/${mission.mission._id}`)}
            >
              Voir le détail
            </Button>
          </DialogActions>

        <PresentationModal
          open={modalOpen}
          onClose={handleClose}
          // talent={createdTalent}
          apiBase={API_BASE}
        />

      </Dialog>
    </Box>

    </LocalizationProvider>
  );
}
